// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__T0psY","logo":"Footer_logo__+JiYo","row":"Footer_row__TCZPv","copyrightRow":"Footer_copyrightRow__UlH7e"};